<template>
    <heads>
        <div class="grid grid-cols-2 gap-4">
            <div class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
                <p class="text-lg font-medium mb-4">List Fees Type</p>
                <breeze-table :searchable="true" :fields="fields" :items="feestypes">
                    <template #status="data">
                        {{data.item.status?'Active':'Inactive'}}
                    </template>
                    <template #action="data">
                        <button-link :href="route('heads.feestype.edit',data.item.id)" >Edit</button-link>
                    </template>
                </breeze-table>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
                <loading :showLoading="form.processing" />
                <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                    <p class="text-lg font-medium mb-4">Add Fees Type</p>
                    <form @submit.prevent="submitForm">
                        <div class="grid grid-cols-8 gap-4 mb-8">
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :value="'Title'"/>
                                <breeze-input required v-model="form.title" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.title:''" />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Status'"/>
                                <breeze-checkbox v-model="form.status" :checked="form.status"/>
                                <breeze-input-error :message="form.errors?form.errors.status:''" />
                            </div>
                        </div>
                        <breeze-button :disabled="form.processing">Submit</breeze-button>
                        <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Fees Type Added!</span>
                        <exception />
                    </form>
                </div>
            </div>
        </div>
    </heads>
</template>

<script>
    import Heads from '@/Pages/Heads/Heads'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import ButtonLink from '@/Components/ButtonLink'
    import CardHeader from '@/Components/CardHeader'
    import { useForm } from '@inertiajs/inertia-vue3'
    import BreezeInputError from '@/Components/InputError'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import Loading from '@/Components/Loading'
    import Exception from '@/Components/Exception'
    import BreezeTable from '@/Components/Table'

    export default {
        components: {
            Heads,
            BreezeInput,
            BreezeLabel,
            ButtonLink,
            CardHeader,
            BreezeInputError,
            BreezeButton,
            BreezeCheckbox,
            Loading,
            Exception,
            BreezeTable
        },
        props:['feestypes'],
        data(){
            return{
                form: useForm({
                    title: '',
                    status: true,
                }),
                fields:[{'key':'title','label':'Title'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]
            }
        },
        methods:{
            submitForm() {
                this.form.post(route('heads.feestype.store'),{
                    preserveScroll: true,
                    onSuccess: () => {this.form.reset(); location.reload()},
                });
            }
        }
    }
</script>
